import 'css-chunksrc/client/scenes/task/allocations/header/styles.scss';export default {
  "header": "_header_w917c_1",
  "label": "_label_w917c_14",
  "resource": "_resource_w917c_20",
  "column": "_column_w917c_25",
  "actionSlot": "_actionSlot_w917c_29"
};